import { differenceInCalendarDays } from 'date-fns';

/** Number of days after launch during which a code is considered "new". */
export const NEW_BADGE_WINDOW_DAYS = 60;

/**
 * True when `launchDate` falls within the last NEW_BADGE_WINDOW_DAYS calendar
 * days, inclusive of today and of the boundary day. Missing, empty, unparseable,
 * or future launch dates return false.
 *
 * `now` is injected so callers control the reference point (deterministic tests).
 */
export const isRecentlyLaunched = (launchDate: string | undefined, now: Date): boolean => {
  if (!launchDate) return false;

  const launched = new Date(launchDate);
  if (Number.isNaN(launched.getTime())) return false;

  const daysSinceLaunch = differenceInCalendarDays(now, launched);
  return daysSinceLaunch >= 0 && daysSinceLaunch <= NEW_BADGE_WINDOW_DAYS;
};
